import PropTypes from 'prop-types';
import { multipleComponentIteratorMap } from './MultipleComponentIteratorMap.utils';
import { IdPropType } from '../../../../services/proptypes';
import { multipleComponentIterationConfig } from '../MultipleComponentIterator/MultipleComponentIterator';
import './MultipleComponentIteratorMap.css';
var propTypes = {
  lookupField: PropTypes.string.isRequired,
  targetValues: PropTypes.arrayOf(IdPropType).isRequired,
  iterator: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  components: PropTypes.arrayOf(multipleComponentIterationConfig()).isRequired,
  limit: PropTypes.number
};
var defaultProps = {
  limit: null
};
export default function MultipleComponentIteratorMap(_ref) {
  var lookupField = _ref.lookupField,
    targetValues = _ref.targetValues,
    iterator = _ref.iterator,
    components = _ref.components,
    limit = _ref.limit;
  return multipleComponentIteratorMap({
    lookupField: lookupField,
    targetValues: targetValues,
    iterator: iterator,
    components: components,
    limit: limit
  });
}
MultipleComponentIteratorMap.propTypes = propTypes;
MultipleComponentIteratorMap.defaultProps = defaultProps;